function klaviyoSubscribe(source, method_type, kid, code, data) {
  var kid = kid,
    code = code,
    data = data;

  var svg = {
    close:
      '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
    copy: '<svg width="36" height="42" viewBox="0 0 36 42" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M33.9545 6H8.04545C7.50297 6 6.9827 6.21071 6.5991 6.58579C6.2155 6.96086 6 7.46957 6 8V40C6 40.5304 6.2155 41.0391 6.5991 41.4142C6.9827 41.7893 7.50297 42 8.04545 42H33.9545C34.497 42 35.0173 41.7893 35.4009 41.4142C35.7845 41.0391 36 40.5304 36 40V8C36 7.46957 35.7845 6.96086 35.4009 6.58579C35.0173 6.21071 34.497 6 33.9545 6ZM33.2727 39.3333H8.72727V8.66667H33.2727V39.3333Z" fill="currentColor"/><path d="M29 2C29 1.46957 28.7917 0.960859 28.4209 0.585787C28.0501 0.210714 27.5471 0 27.0227 0H1.97727C1.45287 0 0.94994 0.210714 0.57913 0.585787C0.208319 0.960859 0 1.46957 0 2V34C0 34.5304 0.208319 35.0391 0.57913 35.4142C0.94994 35.7893 1.45287 36 1.97727 36H2.63636V2.66667H29V2Z" fill="currentColor"/></svg>',
  };

  var success_copy =
    '<span class="close-box" style="color:' +
    data.style.opentextColor +
    ';">' +
    svg.close +
    '</span><div class="code-num">' +
    svg.copy +
    code +
    '</div><textarea readonly="readonly" rows="1">' +
    code +
    "</textarea>";

  var box_success =
    '<div class="box-success"><div class="info"><h4 class="title">' +
    data.success_info.title +
    '</h4><p class="subtitle">' +
    data.success_info.subtitle +
    '</p></div><div class="code-info"><p>' +
    data.success_info.ps +
    '</p><div class="code-num"><span>' +
    svg.copy +
    code +
    '</span><textarea readonly="readonly" rows="1">' +
    code +
    "</textarea></div></div></div>";

  $("body").append(
    '<div class="fixed-subscribe-box-back active" onclick="_gaq.push([_trackEvent,subscriptionBefore,clicked])" style="background-color:' +
      data.style.openbgColor +
      ";color:" +
      data.style.opentextColor +
      ';"><span class="close-box" style="color:' +
      data.style.opentextColor +
      ';">' +
      svg.close +
      '</span><span class="open-fixed">' +
      data.welcome +
      '</span></div><div class="fixed-subscribe-box" style="background-color:' +
      data.style.boxbgColor +
      ";background-image:url(" +
      data.style.boxbgImg +
      ");color:" +
      data.style.boxtextColor +
      ';"><div class="close-box">' +
      svg.close +
      '</div><div class="box-form"><div class="cont-top"><div class="title">' +
      data.title +
      '</div><div class="subtitle">' +
      data.subtitle +
      '</div></div><div id="fixed-sub-kmail"><form id="warranty_signup" action="https://manage.kmail-lists.com/subscriptions/subscribe" data-ajax-submit="https://manage.kmail-lists.com/ajax/subscriptions/subscribe" method="GET" target="_blank" novalidate="novalidate"><input type="hidden" name="g" value="' +
      kid +
      '"><input type="hidden" name="$fields" value="$consent"><input type="hidden" name="$list_fields" value="$consent"><div class="group-input"><input class="email" placeholder="' +
      data.emailTxt +
      '" name="email" type="email" value=""><button type="button" onclick="_gaq.push([_trackEvent,subscriptionAffter,clicked])"  class="submit btn-send" style="color:' +
      data.style.boxbgColor +
      ';">' +
      data.btnTxt +
      '</button></div><div class="msg-alert mb-0"><div class="klaviyo_messages"><div class="success_message" style="display:none;"></div><div class="error_message" style="display:none;"></div></div></div><div class="privacy-info">' +
      data.privacy +
      '</div></form></div></div></div><div class="fixed-subscribe-box-wrap"></div>'
  );

  var $fixed_subscribe_box = $(".fixed-subscribe-box");
  var $fixed_subscribe_box_back = $(".fixed-subscribe-box-back");
  var hostname = window.location.hostname;

  if (getCookie("open-sub") !== "1") {
    setTimeout(function () {
      $fixed_subscribe_box_back.removeClass("active");
      $fixed_subscribe_box.addClass("active");
      SetCookie("open-sub", "1", hostname);
    }, 20000);
  }
  if (getCookie("sub-code")) {
    $fixed_subscribe_box_back.html(success_copy);
    $fixed_subscribe_box.addClass("success");
  }

  $fixed_subscribe_box_back.on("click", ".open-fixed", function () {
    $fixed_subscribe_box_back.removeClass("active");
    $fixed_subscribe_box.addClass("active");
    zE("webWidget", "close");
  });
  $fixed_subscribe_box_back.on("click", ".code-num", function () {
    $fixed_subscribe_box_back.find("textarea").select();
    document.execCommand("Copy");
    $fixed_subscribe_box_back.find(".code-num").html(data.msg.copy);
  });
  $fixed_subscribe_box_back.on("click", ".close-box", function () {
    $fixed_subscribe_box_back.removeClass("active");
  });
  $fixed_subscribe_box.on("click", ".close-box", function () {
    // console.log("close");
    $(this).parents(".fixed-subscribe-box").removeClass("active");
    $fixed_subscribe_box_back.addClass("active");
  });

  $fixed_subscribe_box.on("click", ".code-num", function (event) {
    event.stopPropagation();
    $(this).find("textarea").select();
    document.execCommand("Copy");
    $(this).find(".code-copy-msg").remove();
    $(this).append('<div class="code-copy-msg">' + data.msg.copy + "</div>");
  });
  $fixed_subscribe_box.on("click", function () {
    if ($(this).find(".code-copy-msg").length >= 1) {
      $(this).find(".code-copy-msg").remove();
    }
  });

  $fixed_subscribe_box.on("click", ".btn-send", function () {
    var run = false;
    var emailReg =
      /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
    var $fixed_sub_kmail = $(this).parents("#fixed-sub-kmail");
    var $email = $fixed_sub_kmail.find(".email");
    $fixed_sub_kmail.find(".msg-alert").html("");
    if ($email.val() == "") {
      $fixed_sub_kmail.find(".msg-alert").html(data.msg.empty);
      return true;
    }
    if (!emailReg.test($email.val())) {
      $fixed_sub_kmail.find(".msg-alert").html(data.msg.error);
      return true;
    }
    // $fixed_subscribe_box.addClass("success").find(".box-form").after(box_success).remove();
    // $fixed_subscribe_box_back.html(success_copy)
    // SetCookie('sub-code', code, hostname)
    if (run == false) {
      $(this).submit();
    }
  });

  KlaviyoSubscribe.attachToForms("#warranty_signup", {
    // Hide klaviyo_field_group after submit
    hide_form_on_success: true,
    // redirect to url after success
    // success_url: "http://www.evxample.com/thank-you",
    success: function ($form) {
      $fixed_subscribe_box
        .addClass("success")
        .find(".box-form")
        .after(box_success)
        .remove();
      $fixed_subscribe_box_back.html(success_copy);
      SetCookie("sub-code", code, hostname);
    },
    extra_properties: {
      $source: source,
      $method_type: method_type,
    },
  });
}

function getCookie(c) {
  var d = document.cookie.split("; ");
  for (var b = 0; b < d.length; b++) {
    var a = d[b].split("=");
    if (a[0] == c) {
      return unescape(a[1]);
    }
  }
}
function SetCookie(b, d, a) {
  var c = 14;
  var e = new Date();
  e.setTime(e.getTime() + c * 24 * 60 * 60 * 1000);
  document.cookie =
    b +
    "=" +
    escape(d) +
    ";expires=" +
    e.toGMTString() +
    "; domain=" +
    a +
    ";path=/";
}
